import { useEffect, useRef } from 'react';
import { getCartAnalyticsContext, useAnalyticsEvent, useCartService, type Currency } from '@skin-seoul/service';
import { useCallbackRef } from '@skin-seoul/utils';

/** The drawer stays mounted while its portal closes, so it owns visit and departure events. */
export function useCartVisitAnalytics(isOpen: boolean, currency: Currency) {
  const analytics = useAnalyticsEvent();
  const { useGetCartQuery } = useCartService();
  const { data } = useGetCartQuery({ currency }, { enabled: false });
  const cart = data?.cart;
  const opened = useRef(false);
  const checkedOut = useRef(false);
  const track = useCallbackRef((eventName: string) => {
    if (!cart) {
      return;
    }
    analytics.trackCustom({
      eventName,
      skipGTM: true,
      params: {
        ...getCartAnalyticsContext(cart, 'cart_drawer'),
        ...(eventName === 'view_cart' ? { cart_value: cart.totals.total, source_component: 'ShoppingBagDrawer' } : {}),
      },
    });
  });
  useEffect(() => {
    if (isOpen && cart && !opened.current) {
      opened.current = true;
      checkedOut.current = false;
      track('view_cart');
    } else if (!isOpen && opened.current) {
      opened.current = false;
      if (!checkedOut.current) {
        track('cart_closed');
      }
    }
  }, [isOpen, cart, track]);

  return () => {
    checkedOut.current = true;
  };
}
